var _desc, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocationPinRed = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 200,
  height: 215,
  viewBox: "180 40 320 258",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "Location pin") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A muted rose-red teardrop map marker, slightly shortened, with a white circular hole in the center.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M337 286 C319 244 262 196 262 122 A78 78 0 1 1 418 122 C418 196 361 244 343 286 A4 4 0 0 1 337 286 Z",
  fill: "#AD4A4A",
  stroke: "#8A3A3A",
  strokeWidth: 2,
  strokeLinejoin: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 120,
  r: 30,
  fill: "#ffffff"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocationPinRed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/locationPinRed.f4c6f6cc3e8080edb007789ff9d9f4e5.svg";